import { render, staticRenderFns } from "./changeRegExpirationDate.vue?vue&type=template&id=4967c678&scoped=true"
import script from "./changeRegExpirationDate.vue?vue&type=script&lang=js"
export * from "./changeRegExpirationDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4967c678",
  null
  
)

export default component.exports